import { createGlobalStyle, styled, keyframes, css} from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  nav ul {
    list-style-type: none;
    padding: 0;
  }
  
  nav ul li {
    display: inline;
    margin: 0 1em;
  }
  
  nav ul li a {
    color: white;
    text-decoration: none;
  }
  
  main {
    padding: 1em;
  }


  *, *::before, *::after {
    box-sizing: inherit;
  }
`;

export default GlobalStyle;

// CONSTANTS
export const DEFAULT_TABLE_COLOR = "#42484f";
export const HEADER_BACKGROUND_COLOR = "#194c66";
export const HEADER_TEXT_COLOR = "#ffffff";
export const FOOTER_BACKGROUND_COLOR = HEADER_BACKGROUND_COLOR
export const FOOTER_TEXT_COLOR = HEADER_TEXT_COLOR

//CONTROLS
export const Input = styled.input`
  margin: 4px;
  padding: 5px;
  width: calc(100% - 24px);
  line-height: 1.5; /* Ensure consistent line-height */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */
  border: 1px solid #ccc;

  /* Hide browser's default password reveal button */
  &::-ms-reveal,
  &::-ms-clear {
    display: none;
  }

  &::-webkit-credentials-auto-fill-button {
    visibility: hidden;
    position: absolute;
    right: 0;
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
  }
  
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;


export const Select = styled.select`
  margin: 4px;
  padding: 8px;
  border: 1px solid #ccc;
  box-sizing: border-box;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  justify-content: flex-left;
  align-items: center; /* Align items vertically */
  margin: 4px;
  font-size: 14px;
`;

type ButtonProps = {
  variant?: 'primary' | 'secondary';
};

export const Button = styled.button<ButtonProps>`
  font-family: inherit;
  font-size: 100%;
  font-weight: 500;
  line-height: 1.15;
  margin: 10px;
  padding: 4px 10px;
  text-decoration: none;
  justify-content: center;
  border-radius: 4px;
  min-width: 100px;
  transition: background 0.2s, border 0.2s, box-shadow 0.2s;

  ${(props) =>
    props.variant === 'secondary'
      ? css`
          color: #194C66;
          border: 2px solid #194C66;
          background: #fff;
          box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.25);

          &:hover {
            background: #D9D9D9;
          }
          &:active {
            background: #EFEFEF;
            box-shadow: none;
          }
          &:focus-visible {
            border: 3px solid #000;
            outline: none;
          }
          &:disabled {
            color: #999;
            border: 2px solid #999;
            background: #FFF;
            cursor: not-allowed;
            box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.25);

            &:hover {
              background: #FFF;
            }
          }
        `
      : css`
          /* default to primary */
          color: #ffffff;
          border: 2px solid #194C66;
          background: #194C66;
          box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.25);

          &:hover {
            background: #315F94;
          }
          &:active {
            background: #315F94;
            box-shadow: none;
          }
          &:focus-visible {
            border: 3px solid #000;
            outline: none;
          }
          &:disabled {
            border: 2px solid #999;
            background: #999;
            cursor: not-allowed;
            box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.25);

            &:hover {
              background: #999;
            }
          }
        `}
`;


//OVERLAYS
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 24px;
  z-index: 1000;
`;
export const OverlayText = styled.div`
  color: white;
  font-size: 24px;
  text-align: center;
`;

// MODALS
export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border: 0px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: min(800px, 95vw);
  border-radius: 8px;
  max-height: 90vh;
  max-width: 95vw;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const ModalTitle = styled.h2`
  background: ${DEFAULT_TABLE_COLOR};
  color: white;
  padding: 8px;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px 8px 0px 0px;
  flex-shrink: 0;
`;

export const ModalSubtitle = styled.h3`
  font-size: 1.5em;
  margin: 16px;
  margin-bottom: 1em;
  color: #333;
  font-weight: normal;
`;

export const ModalBody = styled.div`
  background: white;
  padding: 16px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  box-sizing: border-box;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px;
  flex-shrink: 0;
`;

export const ModalRow = styled.div`
  display: flex;
  align-items: center;
  height: auto;
  margin-bottom: 8px;
  gap: 8px;
  box-sizing: border-box;
  min-width: 0;
`;

export const ModalLabel = styled.label`
  white-space: nowrap;
  flex-shrink: 0;
  box-sizing: border-box;
`;

export const StatusMessage = styled.div<{ statusType: string }>`
margin: 8px;
border: 0px solid #ccc;
color: ${(props) => (props.statusType === 'success' ? 'green' : (props.statusType === 'error' ? 'red' : 'black'))};
`;

// Define styled-components for animations
const blinking = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
`;

export const BlinkingIcon = styled(FontAwesomeIcon)`
  animation: ${blinking} 1s infinite;
`;

export const SpinningIcon = styled(FontAwesomeIcon)`
  margin-left: 8px;
  color: blue;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const SearchContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ccc;
  border: 0px solid #bababaff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 400px;
  border-radius: 8px;
  padding: 10px;
`;

export const TableFilterContainer = styled.div`
  margin-bottom: 0px;
  margin-top: 10px;
  margin-left: 20px;
  `;

  export const Required = styled.span`
  color: red;
`;
